import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { Exchange } from '@/assets/icons'
import { useAddMoneyStore } from '@/store/useAddMoneyStore'
import { currencyUtils } from '@/utils'
import { useTheme } from '@/hooks/useTheme'

const { formatDynamicCurrency } = currencyUtils

export const AddMoneyConversionRate: React.FC = () => {
  const theme = useTheme()
  const isFiatMode = useAddMoneyStore((state) => state.isFiatMode)
  const setIsFiatMode = useAddMoneyStore((state) => state.setIsFiatMode)
  const fiatAmount = useAddMoneyStore((state) => state.fiatAmount)
  const cryptoAmount = useAddMoneyStore((state) => state.cryptoAmount)

  const adaptedAmount = isFiatMode ? cryptoAmount : fiatAmount

  const formattedRelativeAmount = formatDynamicCurrency({
    amount: adaptedAmount.amount,
    currencyCode: adaptedAmount.code,
    showDecimals: true,
  })

  const handleToggleCurrencyMode = () => {
    setIsFiatMode(!isFiatMode)
  }

  return (
    <BaseView row align="center" gap={4}>
      <BaseText
        fontSize={18}
        fontFamily="bold"
        color="label.default"
        style={{
          textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        {formattedRelativeAmount || '0'}
      </BaseText>
      <BaseView
        center
        className="cursor-pointer hover:opacity-80 transition-opacity duration-200 active:scale-95"
        style={{
          padding: 8,
          borderRadius: 20,
        }}
        onClick={handleToggleCurrencyMode}
      >
        <Exchange
          size={18}
          color={theme.colors.label.default}
          style={{
            filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))',
          }}
        />
      </BaseView>
    </BaseView>
  )
}
